/**
 * Error messages — API and system errors.
 *
 * Namespace: errors
 */
export const errors = {
  // Network errors
  network: "Nem sikerült kapcsolódni a szerverhez. Kérjük, ellenőrizze az internetkapcsolatát.",
  timeout: "A kérés időtúllépés miatt megszakadt. Kérjük, próbálja újra.",

  // HTTP status errors
  serverError: "Szerverhiba történt. Kérjük, próbálja újra később.",
  unauthorized: "Nincs jogosultsága ehhez a művelethez. Kérjük, jelentkezzen be újra.",
  forbidden: "Hozzáférés megtagadva.",
  notFound: "A keresett erőforrás nem található.",
  validation: "Érvénytelen adatok. Kérjük, ellenőrizze a megadott adatokat.",
  conflict: "A művelet nem hajtható végre. Az erőforrás már létezik.",
  tooManyRequests: "Túl sok kérés. Kérjük, próbálja újra később.",

  // General
  default: "Váratlan hiba történt. Kérjük, próbálja újra.",
} as const;

export type ErrorMessages = typeof errors;
